// add span for backwards compatibility with the single displays
const HEADING_LEVELS = ['h1', 'h2', 'h3', 'span'];

export const taggingProps = {
  taggingId: {
    type: String,
  },
  // TODO: Single items each need their tagging target. When that happens, we need this prop
  taggingTarget: {
    type: String,
  },
};

export const commonProps = {
  // TODO: Why is this specified here?
  image: {
    type: Object,
  },
  cta: {
    type: Object,
  },
  badge: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
  displayMode: {
    type: String,
    default: 'tile',
  },
  theme: {
    type: String,
    default: 'light',
  },
  alignment: {
    type: String,
    default: 'left',
  },
  // TODO: this should be of type Array and should validate its "shape"
  items: {
    type: Object,
    default: null,
  },
  heading: {
    type: String,
    default: 'span',
    validator(value) {
      return HEADING_LEVELS.includes(value);
    },
  },
  /*
   * TODO: fit-content is not quite a great "shape" but it's a sensible and descriptive default
   * This must be re-evaluated and maybe some props / config options should be clobbered together
   */
  shape: {
    type: String,
    default: 'fit-content',
    validator(value) {
      return ['rectangle', 'square', 'circle', 'fit-content'].includes(value);
    },
  },
  alignCaption: {
    type: String,
    default: 'left',
    validator(value) {
      return ['center', 'left'].includes(value);
    },
  },
};
